var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('el-date-picker',{attrs:{"value":_vm.value,"type":"daterange","align":"right","unlink-panels":"","range-separator":"至","start-placeholder":_vm.elForm.disabled ? '' : '开始日期',"end-placeholder":_vm.elForm.disabled ? '' : '结束日期',"picker-options":_vm.pickerOptions},on:{"input":function (val) {
        _vm.$emit('input', val);
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }